export default "__VITE_ASSET__CqTOF049__"